// Security configuration for the EU Whistleblowing Platform

export const securityHeaders = {
  // Prevent MIME type sniffing
  'X-Content-Type-Options': 'nosniff',
  
  // Prevent clickjacking attacks
  'X-Frame-Options': 'DENY',
  
  // Enable XSS filter (legacy, but still useful for older browsers)
  'X-XSS-Protection': '1; mode=block',
  
  // Control referrer information
  'Referrer-Policy': 'strict-origin-when-cross-origin',
  
  // Restrict browser features
  'Permissions-Policy': 'camera=(), microphone=(), geolocation=(), payment=()',
}

// Content Security Policy configuration
export const cspConfig = {
  'default-src': ["'self'"],
  'script-src': [
    "'self'",
    "'unsafe-inline'", // Required for Ant Design and React
    "'unsafe-eval'",   // Required for development (should remove in production)
    'https://vercel.live', // Vercel analytics
  ],
  'style-src': [
    "'self'",
    "'unsafe-inline'", // Required for Ant Design inline styles
  ],
  'font-src': ["'self'", 'data:'], // Allow base64 fonts
  'img-src': ["'self'", 'data:', 'blob:', 'https:'],
  'connect-src': [
    "'self'",
    'https://*.supabase.co',
    'wss://*.supabase.co',
    'https://vercel.live',
  ],
  'frame-ancestors': ["'none'"], // Prevent embedding
  'base-uri': ["'self'"],
  'form-action': ["'self'"],
}

// Convert CSP config to string
export const cspString = Object.entries(cspConfig)
  .map(([key, values]) => `${key} ${values.join(' ')}`)
  .join('; ') + ';'

// Security best practices configuration
export const securityConfig = {
  // Session timeout in milliseconds (30 minutes)
  sessionTimeout: 30 * 60 * 1000,
  
  // Password requirements
  passwordMinLength: 8,
  passwordRequireUppercase: true,
  passwordRequireLowercase: true,
  passwordRequireNumbers: true,
  passwordRequireSpecialChars: true,
  
  // Rate limiting
  maxLoginAttempts: 5,
  loginLockoutDuration: 15 * 60 * 1000, // 15 minutes
  
  // File upload restrictions
  maxFileSize: 50 * 1024 * 1024, // 50MB
  allowedFileTypes: [
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/plain',
    'text/csv',
    'video/mp4',
    'video/quicktime',
    'audio/mpeg',
    'audio/wav',
  ],
  
  // CORS configuration
  allowedOrigins: [
    'https://inuaoxauhyzubhltwdza.supabase.co',
    process.env.NODE_ENV === 'development' ? 'http://localhost:5173' : '',
  ].filter(Boolean),
}

// Sanitization utilities
export const sanitizeInput = (input: string): string => {
  // Basic HTML entity encoding
  return input
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .replace(/\//g, '&#x2F;')
}

// Validate file type
export const isAllowedFileType = (fileType: string): boolean => {
  return securityConfig.allowedFileTypes.includes(fileType)
}

// Validate file size
export const isFileSizeAllowed = (fileSize: number): boolean => {
  return fileSize <= securityConfig.maxFileSize
}